import React from 'react'

type SVGIconProps = {
  alt: string
  title?: string
  className?: string
  xlinkHref: string
  pointerEvents?: string
}

const SVGIcon: React.FC<SVGIconProps> = ({
  className,
  xlinkHref,
  pointerEvents, // Default used to be 'none'
}) => {
  return (
    <svg className={className} pointerEvents={pointerEvents}>
      <use xlinkHref={xlinkHref} />
    </svg>
  )
}

export default SVGIcon
